import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface NoProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onBeginJob: () => unknown
  extensionActions?: ReactNode
}

export function NoProgressionActions({
  isAnyExtensionFlowAvailable,
  onBeginJob,
  extensionActions,
}: NoProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Begin Job"
          variant="primary"
          size="wide-slim"
          onPress={onBeginJob}
          testId="job-progression-set-job-started-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
